/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import {
	BaseComponent,
	ThunderDispatcher
} from "@intuitionrobotics/thunderstorm/frontend";
import {COLORS} from "@res/colors";

export interface OnClear {
	__onClear: () => void;
}

export const dispatch_onClear = new ThunderDispatcher<OnClear, "__onClear">("__onClear");

type Props = {
	onClick: () => void
}

export class ClearFilter
	extends BaseComponent<Props, {}> {

	constructor(props: Props) {
		super(props);
	}

	private renderClearFilter = () => {
		return <div className={`ll_h_c clickable`}
		            style={{
						flex: 1,
			            color: COLORS.neutral_text_dark,
						textDecoration: 'underline',
			            fontSize: 14,
						justifyContent: 'center'
		            }}
		            onClick={this.props.onClick}>
			Clear all filters
		</div>;
	};

	render() {
		return this.renderClearFilter();
	}
}
